import React from 'react';
import { AuthRoles } from "components/auth";

export const ElectronicGuideConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/electronic_guide`,
            component: React.lazy(() => import('./ElectronicGuide'))
        }
    ]
};